import { render, staticRenderFns } from "./ReviewLink.vue?vue&type=template&id=246b8e3c"
import script from "./ReviewLink.vue?vue&type=script&lang=js"
export * from "./ReviewLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports